// ----- State -----
const initialState = {
  isLoggedIn: false,
  userRole: "",
  username: "",
  name: "",
  distributorId: null,
  token: "",
};

// ----- Types -----
// LOGIN
const CLINICIAN_LOGIN_DONE = "CLINICIAN_LOGIN_DONE";
const LOGOUT_DONE = "LOGOUT_DONE";

// ----- Reducer -----
export default function reducer(state = initialState, action) {
  switch (action.type) {
    // LOGIN
    case CLINICIAN_LOGIN_DONE:
      return {
        ...state,
        isLoggedIn: true,
        userRole: action.payload.userRole,
        username: action.payload.username,
        name: action.payload.name,
        distributorId: action.payload.distributorId,
        token: action.payload.token,
      };
    case LOGOUT_DONE:
      return initialState;
    default:
      return state;
  }
}

// ----- Actions -----
// LOGIN
export const validateLogin = ({ token, user }) => (dispatch) => {
  dispatch({
    type: CLINICIAN_LOGIN_DONE,
    payload: {
      userRole: user.role,
      username: user.username,
      name: user.name,
      distributorId: user.distributorId,
      token,
    },
  });
};

export const logout = () => (dispatch) => {
  dispatch({
    type: LOGOUT_DONE,
  });
};
